import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseKey);

// Database types
export interface DbClient {
  id: string;
  name: string;
  slug: string;
  logo_url?: string;
  headline: string;
  introduction: string;
  created_at: string;
  updated_at: string;
}

export interface DbClientData {
  id: string;
  client_id: string;
  data_type:
    | 'demographics'
    | 'personal_values'
    | 'brand_affinity'
    | 'psychological_drivers'
    | 'hobbies_habits'
    | 'daily_routine'
    | 'flexible_sections'
    | 'insights'
    | 'custom_charts'
    | 'ui_settings'
    | 'page_content';
  data: any;
  created_at: string;
  updated_at: string;
}

export interface DbFileUpload {
  id: string;
  client_id: string;
  filename: string;
  file_url: string;
  file_type: 'pdf' | 'image' | 'csv';
  status: 'pending' | 'processing' | 'completed' | 'failed';
  processing_result?: any;
  created_at: string;
  updated_at: string;
}

export interface DbAdminUser {
  id: string;
  username: string;
  password_hash: string;
  email?: string;
  created_at: string;
  last_login?: string;
}
